<template>
  <card :title="title" :table="true">
    <template slot="header">
        <div class="input-group input-group-sm w-50">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <fa :icon="['fal','filter']" fixed-width />
            </span>
          </div>
          <input type="text" class="form-control" :placeholder="$t('filter')" @keyup="filter">
        </div>
        <div class="text-nowrap">
          <span v-if="data && filterKey">
            {{ filteredData.length }} / 
          </span>
          {{ data ? data.length + ' ' + $t('rows') : '' }}
        </div>
    </template>

    <div class="table-wrapper">
      <table class="table table-hover">
        <thead>
          <tr>
            <th v-if="withPreview"></th>
            <th v-for="(key,index) in columns" :key="index" 
                :title="key.title" 
                :width="key.width" 
                :class="{ active: sortKey == key, 'ellipsis' : key.ellipsis != false}"
                @click="sortBy(key.sortBy || key.col)">
                  <fa v-if="key.col == sortKey" :icon="['fas',sortOrders[key.col] > 0 ? 'sort-down' : 'sort-up']" fixed-width />
                  <fa v-else :icon="['fal','sort']" fixed-width />
                  {{ key.title }}
            </th>
            <th v-if="(withEdit || withDelete) && canEdit" :title="$t('tools')" width="120">
              
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="entry in filteredData" :key="entry.id" :class="getBackground(entry)">
            <template v-if="withPreview">
              <td>
                <a v-if="entry.printable_pages && entry.printable_pages.length > 0" :href="'/api/pdf/' + entry.id + '?preview=true'" target="_blank" class="text-danger mr-2" v-tooltip="$t('preview')">
                  <fa :icon="['far','file-pdf']" transform="grow-6" fixed-width />
                </a>
              </td>
              <!---<td>
                <a href="#" class="text-muted mr-0" v-tooltip="$t('approve')"><fa :icon="['far','check-circle']" transform="grow-6" fixed-width/></a>
              </td>-->
            </template>
            <td v-for="(key,index) in columns" :key="index" @click="emitClick(entry)" :class="key.classes">
              <template v-if="typeof key.col == 'object'">
                <span v-for="subkey in key.col" :key="subkey">
                  
                  <fa v-if="subkey.endsWith('active')" :icon="['fas','circle']" class="status" :class="'text-' + (getEntry(key,entry,subkey) ? 'success' : 'danger')" transform="shrink-8 left-2" />
                  
                  <template v-else>
                    {{ getEntry(key,entry,subkey) }}
                  </template>
                </span>

              </template>
              <template v-else>
                  <span class="d-inline-block" style="width: 20px">
                    <fa v-if="key.col == 'attachment.filename' && entry.created_at != entry.updated_at && !moment(entry.updated_at).add(2,'days').isBefore(new Date())" :icon="['fas','clock']" class="text-success mr-1" transform="grow-3" />
                  </span>
                  {{ getEntry(key,entry,key.col) }}
              </template>

            </td>
            <td v-if="(withEdit || withDelete) && canEdit">
              <div class="tools d-flex justify-content-between">
                <router-link v-if="withEdit" :title="$t('edit')" class="text-primary" :to="{path : editRoute + '/' + entry.id + '/edit'}">
                  <fa :icon="['fas', 'pencil']" fixed-width />
                </router-link>
                
                <a href="#"
                    v-if="withReset" 
                    class="text-warning"
                    :title="$t('reset_password')"
                    @click="confirmReset(entry)">
                  <fa :icon="['fas', 'sync']" fixed-width />
                </a>

                <a href="#"
                    v-if="withDelete" 
                    class="delete text-danger"
                    :title="$t('delete')"
                    @click="confirmDelete(entry)">
                    
                    <fa :icon="['fas', 'trash']" fixed-width />
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </card>
</template>

<script>
import store from "~/store";
import axios from "axios";
import swal from "sweetalert2";

export default {
  name: "Grid",
  props: {
    title: String,
    data: { type: Array, default: [] },
    columns: Array,
    editRoute: String,
    deleteRoute: String,
    resetRoute: String,
    withEdit: Boolean,
    withDelete: Boolean,
    withReset: Boolean,
    withPreview: Boolean
  },
  data: function() {
    var sortOrders = {};
    var sortKeys = {};
    this.columns.forEach(function(key) {
      if (key.sortBy) {
        //sortKeys[key.col] = key.sortBy;
        sortOrders[key.sortBy] = 1;
      } else {
        //sortKeys[key.col] = key.col;
        sortOrders[key.col] = 1;
      }
    });

    return {
      sortKey: "",
      sortKeys: sortKeys,
      sortOrders: sortOrders,
      filterKey: "",
      sorting: false
    };
  },
  created() {},
  computed: {
    canEdit() {
      return store.getters["auth/user"].role >= 3;
    },
    filteredData: function() {
      var sortKey = this.sortKey;
      var filterKey = this.filterKey && this.filterKey.toLowerCase();
      var order = this.sortOrders[sortKey] || 1;
      var data = this.data;

      if (filterKey) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
      }
      if (sortKey && data) {
        data = data.slice().sort(function(a, b) {
          if (sortKey.indexOf(".") < 0) {
            a = a[sortKey];
            b = b[sortKey];
          } else {
            let parts = sortKey.split(".");
            a = a[parts[0]][parts[1]];
            b = b[parts[0]][parts[1]];
          }

          a = typeof a == "String" ? a.toLowerCase() : a;
          b = typeof b == "String" ? b.toLowerCase() : b;

          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      return data;
    }
  },
  filters: {
    capitalize: function(str) {
      return str.col.charAt(0).toUpperCase() + str.col.slice(1);
    }
  },
  methods: {
    getBackground(entry) {
      if (entry.status) {
        return "table-" + this.status.color(entry.status);
      }
    },
    filter($event) {
      this.filterKey = $event.target.value;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    getEntry(key,entry,col) {
      
      if (entry != null) {
        let text = '';
        
        if (col.indexOf(".") < 0) {
          text = entry[col];
        } else {
          let parts = col.split(".");

          if (entry[parts[0]]) {
            text = entry[parts[0]][parts[1]];
          }
        }

        text = key.prefix ? key.prefix + text : text;
        text = key.suffix ? key.suffix + text : text;

        return key.translate ? this.$t(text) : text;
      }
    },
    emitClick(entry) {
      this.$emit("row-clicked", entry);
    },
    async confirmDelete(entry) {
      swal({
        title: this.$t("delete") + " &quot;" + entry.name + "&quot;?",
        text: this.$t("cant_undo"),
        type: "error",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: this.$t("delete"),
        confirmButtonClass: "bg-danger",
        cancelButtonText: this.$t("cancel")
      }).then(result => {
        if (result.value) {
          this.deleteEntry(entry);
        }
      });
    },
    async confirmReset(entry) {
      swal({
        title: this.$t("reset_password_for") + " &quot;" + entry.name + "&quot;?",
        text: this.$t("cant_undo"),
        type: "error",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: this.$t("delete"),
        confirmButtonClass: "bg-danger",
        cancelButtonText: this.$t("cancel")
      }).then(result => {
        if (result.value) {
          this.resetPassword(entry);
        }
      });
    },
    async resetPassword(entry){
      
      const { data } = await axios.post(this.resetRoute, {
        'email' : entry.email
      });
    },
    async deleteEntry(entry) {
      if (entry.id) {
        const { data } = await axios.delete(this.deleteRoute + "/" + entry.id);
        this.$emit("update-data");
      }
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Grid.vue